import { TreeNavigatorLogic } from '../../../../tree/navigation/TreeNavigatorLogic';
import { ITranslationKey } from '../../../translations/ITranslationKey';
import { WidgetRepository } from '../WidgetRepository';
import { IRootWidget, isRoot } from '../containers/root';

/**
 * Applica le traduzioni ad un albero di widget, facendo side-effect
 * sull'oggetto.
 */
export function applyTreeTranslationKeys(
  root: IRootWidget | null | undefined,
  translationKeys: ITranslationKey[],
) {
  if (!root) return;
  const translations = new Map(translationKeys.map(k => [k.chiave, k.valore]));

  TreeNavigatorLogic.forEachNode(root, node => {
    if (isRoot(node)) return;
    const widgetType = WidgetRepository.find(node.type);
    if (!widgetType?.translationSchema) {
      console.warn(`[applyTreeTranslationKeys] Widget type ${node.type} translation schema not found.`); // prettier-ignore
      return;
    }

    widgetType.translationSchema.translate(node, translations);
  });
}
